export default __webpack_public_path__ + "rewind-button.png";